// Player de tutorial (mockup "Modal Vídeo A"): vídeo 16:9 com botão fechar
// sobreposto, categoria · duração, título, descrição, botões YouTube e Próximo.
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import SkipNextIcon from "@material-ui/icons/SkipNext";
import useAerosModalStyles from "../../styles/aerosModalStyles";
import { AEROS, stateText } from "../../styles/aerosTokens";
import { categoryOf, durationLabel, youtubeId } from "./helpRules";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  paper: { width: 800, maxWidth: "calc(100vw - 32px)", margin: 16 },
  video: { position: "relative", aspectRatio: "16 / 9", background: "#000", "& iframe": { position: "absolute", inset: 0, width: "100%", height: "100%", border: 0 } },
  close: { position: "absolute", top: 12, right: 12, width: 32, height: 32, borderRadius: 9, backgroundColor: "rgba(7,8,13,0.7)", color: "#F1F2F6", padding: 0, zIndex: 1, "&:hover": { backgroundColor: "rgba(7,8,13,0.9)" }, "& .MuiSvgIcon-root": { fontSize: 18 } },
  info: { padding: "16px 20px", display: "flex", gap: 16, alignItems: "flex-start" },
  cat: { fontSize: 11, fontWeight: 700, letterSpacing: "0.08em", textTransform: "uppercase", color: stateText(theme, AEROS.cyan, "info") },
  title: { fontFamily: AEROS.fontDisplay, fontSize: 16, fontWeight: 700, letterSpacing: "-0.02em", marginTop: 4, color: theme.palette.text.primary },
  desc: { fontSize: 12.5, color: theme.palette.text.secondary, lineHeight: 1.55, marginTop: 6 },
  actions: { display: "flex", flexDirection: "column", gap: 8, flex: "none" },
}));

export default function HelpPlayerModal({ open, help, next, onClose, onNext, catColor }) {
  const classes = useStyles();
  const m = useAerosModalStyles();
  if (!help) return null;
  const id = youtubeId(help.video);
  const dur = durationLabel(help.duration);
  return (
    <Dialog open={Boolean(open)} onClose={onClose} maxWidth={false} classes={{ paper: classes.paper }}>
      <div className={m.form}>
        <div className={classes.video}>
          <IconButton className={classes.close} onClick={onClose} aria-label={i18n.t("aeros.header.close")}><CloseIcon /></IconButton>
          <iframe src={`https://www.youtube.com/embed/${id}?autoplay=1&rel=0`} title={help.title} allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
        </div>
        <div className={classes.info}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div className={classes.cat} style={catColor ? { color: catColor } : undefined}>{categoryOf(help)}{dur ? ` · ${dur}` : ""}</div>
            <div className={classes.title}>{help.title}</div>
            {help.description && <div className={classes.desc}>{help.description}</div>}
          </div>
          <div className={classes.actions}>
            <Button className={m.cancelButton} size="small" startIcon={<OpenInNewIcon />} href={help.link || `https://www.youtube.com/watch?v=${id}`} target="_blank" rel="noopener noreferrer">{i18n.t("aeros.helps.youtube")}</Button>
            {next && <Button className={m.cancelButton} size="small" startIcon={<SkipNextIcon />} onClick={onNext}>{i18n.t("aeros.helps.next")}</Button>}
          </div>
        </div>
      </div>
    </Dialog>
  );
}
